import { Container, Header, Loader } from "semantic-ui-react";
import { VerticalTimeline, VerticalTimelineElement }  from "react-vertical-timeline-component";
import { MdBrokenImage } from "react-icons/md";
import { GiMaterialsScience } from "react-icons/gi";
import { AiOutlineYoutube } from "react-icons/ai";
import { TfiWrite } from "react-icons/tfi";
import { useEffect, useState } from "react";
import axios from "axios";

import "semantic-ui-css/semantic.min.css";
import "react-vertical-timeline-component/style.min.css";

import { API_HOST } from '../constants';

function ProjectsItem(props) {
    let icon = undefined;
    switch(props.type) {
        case "video": icon = <AiOutlineYoutube />; break;
        case "blog": icon = <TfiWrite />; break;
        case "research": icon = <GiMaterialsScience />; break;
        default: icon = <MdBrokenImage />;
    }
    return (
        <VerticalTimelineElement
                className={`vertical-timeline-element--${props.type}`}
                contentStyle={{ border: "1px solid #000" }}
                contentArrowStyle={{ borderRight: "7px solid #000" }}
                date={props.date}
                iconStyle={{ background: "#fff", border: "0px" }}
                icon={icon}
            >
            <Header as="h3" style={{margin:0}}>{props.title}</Header>

            <div style={{margin:"10px 30px"}}
                dangerouslySetInnerHTML={{__html: props.description}}>
            </div>
            <a style={{margin:"50px 50px"}} href={props.url} target="_blank" rel="noreferrer">Read more</a>
            <br></br>
        </VerticalTimelineElement>
    )
}

export default function Projects() {

    let [loading, setLoading] = useState(true);
    let [projects, setProjects] = useState([]);

    function loadProjects() {
        setLoading(true);
        let url = `${API_HOST}/projects.json`;
        axios.get(url).then((response) => {
            setLoading(false);
            if(response.status !== 200) {
                setProjects(require("../data/projects.json"));
            }
            setProjects(response.data);
        }).catch(() => {
            setLoading(false);
            setProjects(require("../data/projects.json"));
        });
    }

    useEffect(() => loadProjects(), []);
    return (
        <div>
            <Container text textAlign="justified">
                <Header as="h1">Featured Projects</Header>
                {/* <a href="https://adityapal.hashnode.dev" target="_blank" rel="noreferrer">All projects</a> */}
                <p>In this section, I list down some of my projects / research publications / blog posts on various topics.</p>
            </Container>
            {
                loading
                ?<Loader active size="medium" inline style={{margin: "100px 0px"}}>Loading Projects</Loader>:
                <VerticalTimeline lineColor="black" layout="1-column-left">
                    {
                        projects.map(
                            (projects, i) => (
                                <ProjectsItem key={i} {...projects} />
                            )
                        )
                    }
                </VerticalTimeline>
            }
        </div>
    );
}